export default "__VITE_ASSET__DVx9CELo__"